var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light_svg__light",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1082.2 800.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light_svg__gradient_20",
    x1: 677.95,
    y1: 594.23,
    x2: 677.95,
    y2: 784.73,
    gradientTransform: "matrix(1 0 0 -1 0 802.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d882ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f2d6ff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "light_svg__gradient_13",
    x1: 974.05,
    y1: 350.22,
    x2: 974.05,
    y2: 541.11,
    gradientTransform: "matrix(1 0 0 -1 0 802.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d882ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f2d6ff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "light_svg__gradient_20-2",
    x1: 757.55,
    y1: 89.53,
    x2: 757.55,
    y2: 281.37,
    xlinkHref: "#light_svg__gradient_20"
  }), /*#__PURE__*/React.createElement("style", null, "@keyframes flash-ani{0%{opacity:.9}to{opacity:.3}}.light_svg__light{animation-name:flash-ani;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:ease-in-out;animation-direction:alternate}"))), /*#__PURE__*/React.createElement("path", {
    className: "light_svg__light",
    style: {
      mixBlendMode: "screen"
    },
    fill: "url(#light_svg__gradient_20)",
    fillRule: "evenodd",
    d: "M639.5 180l-.3-180h77.5l-.3 180-38.5 22.2-38.4-22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light_svg__light",
    style: {
      animationDelay: "1s",
      mixBlendMode: "screen"
    },
    fill: "url(#light_svg__gradient_13)",
    fillRule: "evenodd",
    d: "M935.6 425.7l-.4-180.4h77.7l-.3 180.4-38.5 22.2-38.5-22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light_svg__light",
    style: {
      animationDelay: "2s",
      mixBlendMode: "screen"
    },
    fill: "url(#light_svg__gradient_20-2)",
    fillRule: "evenodd",
    d: "M718.9 684.5l-.4-181.3h78.1l-.3 181.3-38.7 22.4-38.7-22.4z"
  }));
}

export default SvgLight;